import copy from 'clipboard-copy'
import { Badge } from 'evergreen-ui'
import { useState } from 'react'

import CustomIcon from '~/components/CustomIcon'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { track } from '~/utils/analytics'
import { messagePromise } from '~/utils/messages'

export default function DockShareLink() {
  const [isSuccessMounted, setSuccessMounted] = useState(false)

  const copyURL = async () => {
    track('drawer_shortcut_clicked', {
      shortcut: 'share_deploy_preview_url',
      placement: 'dock',
    })
    const url = await messagePromise('LOCATION_HREF', document.location.href)
    copy(url)
    setSuccessMounted(true)
    setTimeout(() => {
      setSuccessMounted(false)
    }, 2500)
  }

  return (
    <ToolGroup isHiddenMobile>
      <>
        <Tool active={false} iconBefore={<CustomIcon name="share" />} onClick={copyURL} title="Copy URL" />
        {isSuccessMounted && (
          <Badge className="lifting" color="green" left={-3} opacity={0} position="absolute" top={16} zIndex={9999}>
            Copied
          </Badge>
        )}
      </>
    </ToolGroup>
  )
}
